module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"country":"Country"},"de":{"country":"Land"}}')
  delete Component.options._Ctor
}
